var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3185_77842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4498 11.0109C16.4766 11.0132 15.5273 10.7181 14.736 10.1675V14.0081C14.7358 14.7194 14.5121 15.4137 14.095 15.9982C13.6779 16.5826 13.0872 17.0293 12.4019 17.2785C11.7166 17.5278 10.9694 17.5677 10.2601 17.3929C9.55086 17.2182 8.91339 16.837 8.43295 16.3005C7.9525 15.7641 7.65198 15.0977 7.57157 14.3907C7.49116 13.6837 7.63469 12.9697 7.98297 12.3441C8.33126 11.7185 8.86768 11.2112 9.52054 10.89C10.1734 10.5688 10.9115 10.4491 11.6363 10.5467V12.4785C11.3046 12.377 10.9485 12.3801 10.6188 12.4872C10.289 12.5943 10.0025 12.7999 9.80012 13.0748C9.59776 13.3496 9.4899 13.6796 9.49195 14.0176C9.494 14.3556 9.60585 14.6843 9.81152 14.9568C10.0172 15.2293 10.3062 15.4317 10.6372 15.535C10.9683 15.6383 11.3244 15.6373 11.6548 15.5321C11.9852 15.4268 12.2729 15.2228 12.477 14.9492C12.681 14.6755 12.7908 14.3461 12.7908 14.0081V6.5H14.736C14.7347 6.6597 14.7484 6.81918 14.7771 6.97643C14.8447 7.32746 14.9853 7.6614 15.1902 7.95781C15.3951 8.25423 15.66 8.50689 15.9688 8.70034C16.4081 8.98274 16.9232 9.13326 17.4498 9.13315V11.0109Z",
    fill: "#2B2B2E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#2B2B2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3185_77842",
    x: 7.5498,
    y: 6.5,
    width: 9.90039,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3185_77842"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.acb8cbcaa4c493d336a1c7dd38db8b72.svg";
export { ForwardRef as ReactComponent };